import React from 'react'

import { SideHeader, PageHeader, Announcements } from '../../components'
import CustomTitle from '../../utils/CustomTitle'

import './AnnouncementPage.css'

function AnnouncementPage() {
    return (
        <div className='announcementPage'>
            <CustomTitle title="MEC CS | Announcements" />
            <PageHeader image="https://res.cloudinary.com/meccs/image/upload/v1660708279/Assets/banner_temp_tdqgqv.jpg" />
            <div className='page__section'>
                <SideHeader title="Announcements" />
                <Announcements />
            </div>
        </div>
    )
}

export default AnnouncementPage